import { render, staticRenderFns } from "./dialogqyzz.vue?vue&type=template&id=71fc6c1b&scoped=true&"
import script from "./dialogqyzz.vue?vue&type=script&lang=js&"
export * from "./dialogqyzz.vue?vue&type=script&lang=js&"
import style0 from "./dialogqyzz.vue?vue&type=style&index=0&id=71fc6c1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc6c1b",
  null
  
)

export default component.exports